import { render, staticRenderFns } from "./InitScanCheckingForm.vue?vue&type=template&id=067278f4&scoped=true&"
import script from "./InitScanCheckingForm.vue?vue&type=script&lang=js&"
export * from "./InitScanCheckingForm.vue?vue&type=script&lang=js&"
import style0 from "./InitScanCheckingForm.vue?vue&type=style&index=0&id=067278f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067278f4",
  null
  
)

export default component.exports